<template>
  <svg viewBox="0 0 24 24" v-on="$listeners">
    <path
      d="M11 11l5.76-7.38a1 1 0 0 0-.17-1.4A1 1 0 0 0 16 2H2a1 1 0 0 0-.62.22a1 1 0 0 0-.17 1.4L7 11v5.87a1 1 0 0 0 .29.83l2 2a1 1 0 0 0 1.41 0a1 1 0 0 0 .3-.83V11m2 5l5 5l5-5z"
      fill="currentColor"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'filters',
}
</script>